module.exports = __webpack_public_path__ + "img/38.8.6d8b1003.png";